module.exports = __webpack_public_path__ + "static/media/SAPTalent-card-habilities-woman-new.e8420268.png";